<script setup lang="ts">
import { ref, onMounted, computed, onBeforeUnmount, defineProps } from "vue";
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/ar';
import { displayService } from '@/_services';

const props = defineProps<{
  fontFamily: string;
  fontSize: number;
  fontColor: string;
  fontWeight: string;
  timeZone: string;
}>();

// const language = ref("en");
// const getLanguage=()=>{
//   const lang = localStorage.getItem("Language") || "en";
//   if(lang == "fr"){
//     language.value = "fr";
//     moment.locale('fr');
//   }else if(lang == "ar"){
//     language.value = "ar";
//     moment.locale('ar');
//   }else {
//     language.value = "en";
//     moment.locale('en');
//   }
// }

const currentDate = ref(new Date());
const dateTimer = ref<number | null>(null);
const timezoneOffset = ref<number | null>(null); // Store the timezone offset in milliseconds

const formattedDate = computed(() => {
  return moment(currentDate.value).locale('fr').format('dddd D MMM YYYY').replace(/^([a-zA-Z])/,
    (match) => match.toUpperCase()
  );
  // if (language.value === 'ar') {
  //   const date = moment(currentDate.value).locale('ar');
  //   //format date as arabic 
  //   const formatted = date.format('dddd D MMMM، YYYY');
  //   //replace arabic digits with latin
  //   return formatted.replace(/[٠-٩]/g, d => '0123456789'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)]);
  // }
  // //default format for other langs
  // return moment(currentDate.value).format('dddd D MMM, YYYY').replace(/^([a-zA-Z])/,
  //   (match) => match.toUpperCase()
  // );
});

const getDateTimeZone = async () => {
  try {
    const formData = new FormData();
    formData.append("time_zone", props.timeZone);
    const response = await displayService.getDateTime(formData);
    const apiDateTime = response.dateTime; // "2025-07-09 15:14:39"
    
    // Parse the API date time
    const apiDate = moment(apiDateTime, 'YYYY-MM-DD HH:mm:ss');
    const localDate = moment(); // Current local time
    
    // Calculate the offset between API time and local time
    // This offset will be used to maintain the correct timezone time
    timezoneOffset.value = apiDate.valueOf() - localDate.valueOf();
    
    // Set the current date to the timezone date
    currentDate.value = apiDate.toDate();
    
    console.log('Timezone offset calculated:', timezoneOffset.value, 'ms');
    console.log('API time:', apiDateTime);
    console.log('Local time:', localDate.format('YYYY-MM-DD HH:mm:ss'));
    
  } catch (e) {
    console.log("error getting dateTimezone", e);
    // Fallback to local time if API fails
    timezoneOffset.value = null;
    currentDate.value = new Date();
  }
};

onMounted(async () => {
  // Only call API if timeZone is provided and not empty
  if (props.timeZone && props.timeZone.trim() !== '') {
    await getDateTimeZone();
  } else {
    // Use local time if no timezone specified or empty string
    timezoneOffset.value = null;
    currentDate.value = new Date();
  }
  
  // getLanguage();
  moment.locale('fr'); 
  
  // update date every minute
  dateTimer.value = window.setInterval(updateDate, 60000);
});

onBeforeUnmount(() => {
  if (dateTimer.value) {
    window.clearInterval(dateTimer.value);
  }
});

function updateDate() {
  if (timezoneOffset.value !== null) {
    // Apply the timezone offset to maintain the correct timezone time
    const localTime = new Date();
    const timezoneTime = new Date(localTime.getTime() + timezoneOffset.value);
    currentDate.value = timezoneTime;
  } else {
    // Use local time if no timezone offset
    currentDate.value = new Date();
  }
}
</script>

<script lang="ts">
export default {
  name: "DateWidget",
};
</script>

<template>

  <div
    class="date-widget"
    :style="{
      fontFamily: fontFamily,
      fontSize: `${fontSize}px`,
      color: fontColor,
      fontWeight: fontWeight === 'bold' ? 'bold' : 'normal',
      fontStyle: fontWeight === 'italic' ? 'italic' : 'normal',
      textDecoration: fontWeight === 'underline' ? 'underline' : 'none',
    }"
  >
    {{ formattedDate }}
  </div>
</template>

<style scoped>
.date-widget {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;
}
</style>
